import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@core_services/auth.service";

export function AuthGuard(shouldBeAuthenticated: boolean): CanActivateFn {
    return () => {
        const authService: AuthService = inject(AuthService);
        const router = inject(Router);

        if (shouldBeAuthenticated) {

            if (!authService.authenticated) {
                router.navigate(['/auth'])
            }
            
            return authService.authenticated;
        } else {

            if (authService.authenticated) {
                router.navigate(['/'])
            }

            return !authService.authenticated;
        }

    };
}